import React, { useState, useEffect } from "react";
import { SocialIcon } from "react-social-icons";
import { FaPhone } from "react-icons/fa";

const socialUrls = [
  { type: "phone", url: "tel:+918806003303", gradient: "linear-gradient(135deg, #25d366, #128C7E)" },
  { type: "social", url: "https://www.instagram.com/travelwithzab", network: "instagram", gradient: "linear-gradient(135deg, #f58529, #dd2a7b, #8134af, #515bd4)" },
  { type: "social", url: "https://wa.me/8806003303", network: "whatsapp", gradient: "linear-gradient(135deg, #25d366, #128C7E)" },
  { type: "social", url: "https://www.facebook.com/share/1VwM93oXJf", network: "facebook", gradient: "linear-gradient(135deg, #1877f2, #4e9af1)" },
];

const FloatingSocialIcons = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 640); // sm breakpoint
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const containerStyle = {
    position: "fixed",
    bottom: isSmallScreen ? 16 : 24,
    right: isSmallScreen ? 16 : 24,
    display: "flex",
    flexDirection: "column",
    gap: isSmallScreen ? "8px" : "12px",
    zIndex: 99999,
  };

  const wrapperStyle = (gradient) => ({
    background: gradient,
    padding: isSmallScreen ? "6px" : "8px",
    borderRadius: "50%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    cursor: "pointer",
    width: isSmallScreen ? "44px" : "66px", // fixed to keep circle shape
    height: isSmallScreen ? "44px" : "66px",
  });

  const iconStyle = {
    width: isSmallScreen ? 28 : 50,
    height: isSmallScreen ? 28 : 50,
  };

  return (
    <div style={containerStyle}>
      {socialUrls.map((item) => (
        <div
          key={item.url}
          style={wrapperStyle(item.gradient)}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.1)";
            e.currentTarget.style.boxShadow = "0 4px 15px rgba(0,0,0,0.3)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "none";
          }}
        >
          {item.type === "social" ? (
            <SocialIcon
              url={item.url}
              network={item.network}
              bgColor="transparent"
              fgColor="#fff"
              style={iconStyle}
              target="_blank"
              rel="noopener noreferrer"
            />
          ) : (
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%" }}
            >
              <FaPhone style={{ width: isSmallScreen ? 20 : 36, height: isSmallScreen ? 20 : 36 }} color="#fff" />
            </a>
          )}
        </div>
      ))}
    </div>
  );
};

export default FloatingSocialIcons;
